import { Selector } from "@reduxjs/toolkit";

import { UaaSelectors } from "@com.mgmtp.a12.uaa/uaa-authentication-client";

import { getLatestFVManifestByKey } from "../../app/slices/fachverfahren/selectors";
import { ModulFState } from "../../app/slices/store";
import { getUsersForFV } from "../../app/slices/users/selectors";
import { AssigneeCandidate } from "../../app/slices/users/types";
import { isAllowedRuntimeModule } from "../../utilities/user";

const EMPTY_ASSIGNEE_CANDIDATES: readonly AssigneeCandidate[] = [];

export function selectAssigneeCandidatesCreator(
	fvKey: string,
	runtimeModules: "Vorgangszuweisung" | "Wiedervorlagenzuweisung" | "Stammdatenzuweisung" | undefined
): Selector<ModulFState, readonly AssigneeCandidate[] | undefined, never> {
	const selectLatestFVManifestByKey = getLatestFVManifestByKey(fvKey);
	return function selectAssigneeCandidates(state) {
		if (!runtimeModules) {
			return EMPTY_ASSIGNEE_CANDIDATES;
		}

		const user = UaaSelectors.user(state as unknown as Record<string, unknown>);
		const manifest = selectLatestFVManifestByKey(state);
		if (isAllowedRuntimeModule(user, runtimeModules, manifest)) {
			return getUsersForFV(manifest)(state);
		} else {
			return EMPTY_ASSIGNEE_CANDIDATES;
		}
	};
}
